import React from "react";

function BS4_InputGroups() {
  return (
    <div>
      <h1>BS4_InputGroups Component</h1>
      <p>This is the BS4_InputGroups tutorial page content.</p>
    </div>
  );
}

export default BS4_InputGroups;
